import { css } from '@leafygreen-ui/emotion';
import { spacing } from '@leafygreen-ui/tokens';

export const backLinkBaseStyles = css`
  gap: ${spacing[100]}px;
  display: inline-flex;
`;
